// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedRgbChannelsBlue_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0H16V16H0V0Z" fill="#2E7AF5"/>
  <path d="M5 12.1719V3.76953H8.05859C8.99609 3.76953 9.7168 3.94141 10.2207 4.28516C10.7246 4.62891 10.9766 5.11328 10.9766 5.73828C10.9766 6.19141 10.8223 6.58789 10.5137 6.92773C10.209 7.26758 9.81836 7.50391 9.3418 7.63672V7.66016C9.93945 7.73438 10.416 7.95508 10.7715 8.32227C11.1309 8.68945 11.3105 9.13672 11.3105 9.66406C11.3105 10.4336 11.0352 11.0449 10.4844 11.498C9.93359 11.9473 9.18164 12.1719 8.22852 12.1719H5ZM6.89258 5.16406V7.15625H7.72461C8.11523 7.15625 8.42188 7.0625 8.64453 6.875C8.87109 6.68359 8.98438 6.42188 8.98438 6.08984C8.98438 5.47266 8.52344 5.16406 7.60156 5.16406H6.89258ZM6.89258 8.5625V10.7773H7.91797C8.35547 10.7773 8.69727 10.6758 8.94336 10.4727C9.19336 10.2695 9.31836 9.99219 9.31836 9.64062C9.31836 9.30469 9.19531 9.04102 8.94922 8.84961C8.70703 8.6582 8.36719 8.5625 7.92969 8.5625H6.89258Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedRgbChannelsBlue is a generated icon component.
 */
let IconMedRgbChannelsBlue = IconMedRgbChannelsBlue_1 = class IconMedRgbChannelsBlue extends IconBaseElement {
    render() {
        return html `${IconMedRgbChannelsBlue_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedRgbChannelsBlue.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedRgbChannelsBlue = IconMedRgbChannelsBlue_1 = __decorate([
    customElement('zui-icon-med-rgb-channels-blue')
], IconMedRgbChannelsBlue);
export { IconMedRgbChannelsBlue };
